import { useEffect } from "react";
import * as moment from "jalali-moment";

import { reOrderArray } from "../utils";
import { items } from "../components/MonthSelector/__items__";

export const useMonthSelector = ({ value, onChange, selectedStartMonth }) => {
  const thisMonthIndex = moment().format("MM") - 1;
  const thisYear = moment().format("YY");
  const restIndex = 11 - thisMonthIndex;
  const orderedMonthes = reOrderArray(items, thisMonthIndex);
  const disabledMonthesIndex = selectedStartMonth
    ? orderedMonthes.findIndex((item) => item.value === selectedStartMonth)
    : -1;
  const nextYear = String(Number(thisYear) + 1).split(1);
  const getYear = (index) => (index > restIndex ? nextYear : thisYear);
  const isDisabled = (index) => index <= disabledMonthesIndex;
  const selected = orderedMonthes.find((item) => item.value === value);
  const selectedIndex = orderedMonthes.findIndex(
    (item) => item.value === value
  );

  useEffect(() => {
    if (
      orderedMonthes &&
      value &&
      orderedMonthes.findIndex((item) => item.value === value) <=
        disabledMonthesIndex
    ) {
      onChange(undefined);
    }
    // eslint-disable-next-line
  }, [selectedStartMonth, value]);

  return {
    orderedMonthes,
    isDisabled,
    getYear,
    selected,
    selectedIndex,
  };
};
